"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useMemo, useState } from "react";
import { hasData } from "@/helpers/has-data";
import { Section } from "@/components/section";
import { Box } from "@/components/ui/box";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CategorizedCoursesContent } from "@/components/categorized-courses-content";
import { CategorizedCoursesLoader } from "@/components/loadings/categorized-courses-loader";
type CategorizedCoursesProps = {
  section: PageSections;
  data: {
    categorizedCourses: CategorizedCoursesInterface[];
  };
};
const CategorizedCourses = props => {
  const $ = _c(24);
  const {
    section,
    data
  } = props;
  const [selectedCategory, setSelectedCategory] = useState(null);
  data?.categorizedCourses;
  const categories = data?.categorizedCourses;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      label: "Select your preferred domain",
      value: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== categories) {
    t1 = [t0, ...(categories?.map(_temp) || [])];
    $[1] = categories;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const items = t1;
  if (!hasData(data)) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = val => setSelectedCategory(val);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectTrigger className="w-full sm:w-max"><SelectValue /></SelectTrigger>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SelectLabel>Domains</SelectLabel>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== categories) {
    t5 = categories?.map(_temp2);
    $[6] = categories;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <SelectContent alignItemWithTrigger={false}><SelectGroup>{t4}{t5}</SelectGroup></SelectContent>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== items || $[11] !== t6) {
    t7 = <Box className="flex justify-end"><Select items={items} onValueChange={t2}>{t3}{t6}</Select></Box>;
    $[10] = items;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CategorizedCoursesLoader />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== data?.categorizedCourses) {
    t9 = data?.categorizedCourses || [];
    $[14] = data?.categorizedCourses;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== selectedCategory || $[17] !== t9) {
    t10 = <Suspense fallback={t8}><CategorizedCoursesContent data={t9} selectedCategory={selectedCategory} /></Suspense>;
    $[16] = selectedCategory;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== section.sectionClass || $[20] !== section.sectionId || $[21] !== t10 || $[22] !== t7) {
    t11 = <Section id={section.sectionId} className={section.sectionClass}>{t7}{t10}</Section>;
    $[19] = section.sectionClass;
    $[20] = section.sectionId;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
export default CategorizedCourses;
function _temp(item) {
  return {
    label: item.name,
    value: item.id
  };
}
function _temp2(item_0) {
  return <SelectItem key={item_0.id} value={item_0.id}>{item_0.name}</SelectItem>;
}